import React, { useState } from "react";
// import "./ManualDepositPopup.css";
import { IoChevronBackSharp } from "react-icons/io5";
import {
  __,
  addNewStyle,
  API,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../Helper";
import axios from "axios";
import Cookies from "js-cookie";
import { QRCodeCanvas } from "qrcode.react";
import Storage from "../../../Storage";


function OnlineDeposit({ isOpen, onClose }) {
  const [amount, setAmount] = useState("");
  const [utrNumber, setUtrNumber] = useState("");
  const [mobile, setMobile] = useState("");
  const [orderId, setOrderId] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1); // Step 1 for amount entry, Step 2 for QR/UTR entry
  const [depositType, setDepositType] = useState("manual"); // New state for deposit type selection
  const [loading, setLoading] = useState(false)
  const [isVerifyPayment, setIsVerifyPayment] = useState(false)
  const [payLink, setPayLink] = useState("")

  if (!isOpen) return null;



  const handleIndianPayGatewayDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    if (window.gtag) {
      window.gtag("event", "deposit_initiated", {
        value: parseFloat(amount) || 0,
        currency: Storage?.getKey("currency") || "INR",
        items: [{ item_name: "Deposit Initiated", price: parseFloat(amount) || 0, quantity: 1 }]
      });
    }

    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }

    try {
      // Sending POST request to the API
      const response = await axios.post(`${API}/payment/api/paynow/apihome`, {
        money: parseFloat(amount),
        uid: getUID || parseFloat(Cookies.get("uid")),
      });

      const data = response?.data;

      // Check if response data is valid
      if (!data) {
        alertMessage("Something went wrong! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Handle error status from the API
      if (data?.status === false) {
        alertMessage(data?.message || "Payment failed! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      console.log(data)

      // Redirect to the provided web URL
      if (data?.urls?.web_url || data?.recharge) {

        setOrderId(data?.recharge?.orderId)
        // window.location.href = data.urls.web_url;
        setPayLink(data.urls.web_url)
        setIsVerifyPayment(true)
      } else {
        sendNotfication("Payment URL is missing! Please contact support.", "danger", "bottom-left");

      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication("An unexpected error occurred! Please try again later.", "danger", "bottom-left");

    } finally {
      setLoading(false); // Reset loading state in all cases
    }
  };
  const handleSubmitUtrapiHomeGatewayDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    if (window.gtag) {
      window.gtag("event", "deposit_initiated", {
        value: parseFloat(amount) || 0,
        currency: Storage?.getKey("currency") || "INR",
        items: [{ item_name: "Deposit Initiated", price: parseFloat(amount) || 0, quantity: 1 }]
      });
    }

    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }

    //   let auth = req.body.uid;
    // let orderId = req.body.order_id;
    // let utr_number = req.body.utr_number;
    // let mobile = req.body.mobile;

    try {
      // Sending POST request to the API
      const response = await axios.post(`${API}/payment/wallet/verify/apihome`, {
        money: parseFloat(amount),
        uid: getUID || parseFloat(Cookies.get("uid")),
        utr_number: utrNumber,
        order_id: orderId,
        mobile: mobile
      });

      const data = response?.data;

      if (!data || data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
      } else {
        sendNotfication(data.message, "success", "bottom-left");
        if (window.gtag) {
          window.gtag("event", "purchase", {
            transaction_id: utrNumber || "",
            value: parseFloat(amount) || 0,
            currency: Storage?.getKey("currency") || "INR",
            items: [
              {
                item_name: "Online Deposit",
                price: parseFloat(amount) || 0,
                quantity: 1
              }
            ]
          });
        }
        if (window.fbq) {
          window.fbq('track', 'Purchase', {
            value: parseFloat(amount) || 0,
            currency: Storage?.getKey("currency") || "INR",
            content_ids: [utrNumber || 'deposit'],
            content_type: 'product'
          });
        }
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        error.response.data.message,
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        <div className="vip2-popup-page" style={{ background: "#000" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />

          </div>
          Online Method
        </div>
        <div
          className="main-int-overflow-sroll"
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0px 0px 10px 10px ",
          }}
        >
          <div
            style={{
              background: "#000",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }} className="main-int-uew-1235">
              <div className="main-int-uew-1236">Deposit Currency</div>
              <div className="main-int-uew-1237">
                <img
                  className="main-int-uew-1238"
                  src="/assets/bcimages/USDT.png"
                  alt="USDT"
                />
                <div>{Storage?.getKey("currency")}</div>
              </div>
            </div>
            <div className="main-int-uew-new-1">Online Deposit</div>
            <div className="popup-body-inner-main-543">
              <div
                style={{ textAlign: "start" }}
                className="amount-input-inner-main-543"
              >
                <img style={{ width: "60px" }} src="/assets/images/USDT.png" />
              </div>
            </div>

            {/* <div
              style={{
                margin: "20px 0px",
                background: "#514634",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "10px",
              }}
            >
              <img
                style={{ width: "50px" }}
                src="/assets/images/bonus-gift.webp"
              />
              <div style={{ fontWeight: "bold", textAlign: "start" }}>
                Get extra <span style={{ color: "#FF9820" }}>180%</span> bonus
                on minimum of{" "}
                <span style={{ color: "#FF9820" }}>$1,056.84</span> deposit
              </div>
            </div> */}


            {
              isVerifyPayment ?
                (<>


                  <div className="main-int-uew-new-1 mt-2">Note: After payment Submit UTR Number</div>

                  <div className="flex flex-wrap justify-center gap-6 p-6">
                    <div key={1} className="text-center p-4 border shadow-lg rounded-xl">
                      <h2 className="text-lg font-semibold mb-2">{"UPI"}</h2>
                      <QRCodeCanvas value={payLink} size={180} />
                      <p className="mt-2 text-sm text-gray-600">Scan to pay via {"UPI"}</p>
                    </div>
                  </div>
                  <div className="p-2 mt-3">
                    <a
                      href={payLink} className="submit-button-inner-main-543">Pay ${amount}</a>
                  </div>

                  <div className="main-int-uew-new-1">UTR Number:</div>
                  <div className="popup-body-inner-main-543">
                    <input
                      className="amount-input-inner-main-543 mb-3"
                      type="number"
                      placeholder="Enter UTR Number"
                      value={utrNumber}
                      onChange={(e) => setUtrNumber(e.target.value)}
                    />
                    <input
                      className="amount-input-inner-main-543"
                      type="number"
                      placeholder="Enter mobile Number"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                    <button
                      onClick={handleSubmitUtrapiHomeGatewayDeposit} className="submit-button-inner-main-543">Submit</button>
                  </div>
                </>) :
                (<>
                  <div className="main-int-uew-new-1">10 - 50,000 USDT</div>

                  <div className="popup-body-inner-main-543">
                    <input
                      className="amount-input-inner-main-543"
                      type="number"
                      placeholder="Enter Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    <button
                      onClick={handleIndianPayGatewayDeposit} className="submit-button-inner-main-543">Proceed to payment</button>
                  </div>
                </>)
            }


            <div
              className="deposit-rules-text-12"
              style={{
                background: "#314940",
                color: "#B3BEC1",
              }}
            >
              <div>
                1. Your transfer amount has to MATCH the submission amount.
              </div>
              <div>
                2. Each Order ID can ONLY be used once to avoid duplicates.
              </div>{" "}
              <div>
                3. Please follow the deposit guideline to make deposit,
                otherwise your deposit will be missing.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnlineDeposit;
